
export enum SmilyValueTypes {
    VERYBAD = "VERYBAD",
    POOR = "POOR",
    MEDIUM = "MEDIUM",
    GOOD = "GOOD",
    EXCELLENT = "EXCELLENT"
}

type ReportDetails = Readonly<{
    startDate: string;
    endDate: string;
    reportTime: string;
}>;

type ReportSummary = Readonly<{
    averageScore: number;
    value: SmilyValueTypes;
    numberOfRatings: number;
}>

type Smiley = Readonly<{
    value: SmilyValueTypes;
    score: number;
    numberOfRatings: number;
}>

export type Report = Readonly<{
    reportDetails: ReportDetails;
    reportSummary: ReportSummary;
    smileys: Smiley[];
}>
